export const QUIZ_NEXT_STEP = 'QUIZ_NEXT_STEP';
export const QUIZ_PREV_STEP = 'QUIZ_PREV_STEP';
export const QUIZ_REQUEST_DATA = 'QUIZ_REQUEST_DATA';
export const QUIZ_CHANGE_ANSWERS = 'QUIZ_CHANGE_ANSWERS';
export const QUIZ_SHOW_TARIFF = 'QUIZ_SHOW_TARIFF';
export const QUIZ_ERROR = 'QUIZ_ERROR';
export const QUIZ_SET_TARIFF = 'QUIZ_SET_TARIFF';
export const QUIZ_SET_ROUTER = 'QUIZ_SET_ROUTER';
export const QUIZ_SET_TV_BOX = 'QUIZ_SET_TV_BOX';
export const QUIZ_CLEAR_QUESTIONS = 'QUIZ_CLEAR_QUESTIONS';
export const QUIZ_SET_IS_SENDED = 'QUIZ_SET_IS_SENDED';
export const QUIZ_SET_IS_SHOW = 'QUIZ_SET_IS_SHOW';
export const QUIZ_SEND_ERROR = 'QUIZ_SEND_ERROR';
export const QUIZ_SET_TARIFFS = 'QUIZ_SET_TARIFFS';
